import React from 'react';
import { Button, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import type { TaskHistoryItem } from '../../types/taskHistory';
import {
  buildTaskHistoryObjectPath,
  resolveTaskHistoryObjectNavigation
} from '../../utils/taskHistoryNavigation';

const { Text } = Typography;

export interface TaskHistoryObjectLinkProps {
  item: Pick<
    TaskHistoryItem,
    | 'entityType'
    | 'applicationId'
    | 'routeId'
    | 'routeStopId'
    | 'scope'
    | 'objectLabel'
  >;
}

const TaskHistoryObjectLink: React.FC<TaskHistoryObjectLinkProps> = ({ item }) => {
  const navigate = useNavigate();
  const target = resolveTaskHistoryObjectNavigation(item);

  if (!target) {
    return (
      <Text type="secondary" style={{ fontSize: 13 }}>
        Объект недоступен
      </Text>
    );
  }

  const label = item.objectLabel?.trim() || '—';

  return (
    <Button
      type="link"
      size="small"
      style={{ padding: 0, height: 'auto', maxWidth: '100%', whiteSpace: 'normal', textAlign: 'left' }}
      onClick={() => navigate(buildTaskHistoryObjectPath(target))}
    >
      {label}
    </Button>
  );
};

export default TaskHistoryObjectLink;
